import {
  mapMembershipRoleToLegacyRole,
} from "./membershipHelpers";

/**
 * Dual-read adapter: enriches legacy users-row actor with Org.v1 membership fields
 * without breaking permissions.js role checks.
 */
export function enrichActorWithMembership(
  userRow,
  { profile, membership, managerSupabaseUserId: managerSupabaseUserIdFromBundle } = {},
) {
  if (!userRow) {
    return userRow;
  }

  if (!membership) {
    return userRow;
  }

  const legacyRole = mapMembershipRoleToLegacyRole(membership.role);
  const managerSupabaseUserId =
    managerSupabaseUserIdFromBundle ??
    membership.manager_supabase_user_id ??
    userRow.manager_supabase_user_id ??
    null;

  return {
    ...userRow,
    role: legacyRole,
    membership_id: membership.id,
    membership_role: membership.role,
    profile_id: profile?.id ?? membership.profile_id ?? null,
    organization_id: membership.organization_id,
    is_system_owner: profile?.is_system_owner === true,
    employee_name: membership.employee_name || userRow.employee_name,
    email: membership.email ?? userRow.email,
    phone: membership.phone ?? userRow.phone,
    classification_name:
      membership.classification_name ?? userRow.classification_name,
    hourly_rate: membership.hourly_rate ?? userRow.hourly_rate,
    payroll_type: membership.payroll_type ?? userRow.payroll_type,
    payroll_access:
      membership.payroll_access ?? userRow.payroll_access ?? false,
    finance_access:
      membership.finance_access ?? userRow.finance_access ?? false,
    trade_id: membership.trade_id ?? userRow.trade_id,
    trade_name:
      membership.trade_name ??
      membership.trades?.trade_name ??
      userRow.trade_name ??
      userRow.trades?.trade_name ??
      null,
    manager_supabase_user_id: managerSupabaseUserId,
  };
}
